"use client";
import React, { useEffect, useState } from "react";
import {
  accordionLabel,
  accordionLabelActive,
  accordionRadio,
  accordionHeaderContainer,
  accordionRightContent,
  accordionLabelWithDescription,
  accordionLabelWithDescriptionIcon,
  accordionLabelDescriptionIcon
} from "./Accordion.css";
import type { TextVariants } from "@shared/ui.primitives";
import { Typography } from "@shared/ui.primitives";

export type AccordionItemLabelProps = {
  value?: string;
  selectedValue?: string | null;
  onChange?: (value?: string) => void;
  header?: string;
  description?: string;
  rightContent?: React.ReactNode;
  radioName: string;
  headerVariant?: TextVariants;
  icon?: React.ReactNode;
};

export const AccordionItemLabel: React.FC<AccordionItemLabelProps> = ({
  value,
  selectedValue,
  onChange,
  header,
  description,
  rightContent,
  radioName,
  headerVariant = "body-md",
  icon
}) => {
  const isSelected = selectedValue === value;

  const accordionWithDescriptionStyling = description?.length
    ? accordionLabelWithDescription
    : "";
  const radioId = `${radioName}-${value}`;
  const [isHyrdated, setIsHydrated] = useState(false);
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <div
      data-testid={`accordion-radio-${radioName}`}
      className={`${accordionLabel} ${accordionWithDescriptionStyling} ${
        isSelected ? accordionLabelActive : ""
      }`}
      onClick={() => onChange?.(value)}
    >
      <input
        type="radio"
        name={radioName}
        disabled={!isHyrdated}
        id={radioId}
        value={value}
        checked={isSelected}
        className={accordionRadio}
        aria-label={header}
      />

      <div className={accordionHeaderContainer}>
        <Typography variant={headerVariant}>{header}</Typography>
        <div className={accordionLabelWithDescriptionIcon}>
          <Typography variant="smallprint-md">{description}</Typography>
          {icon && <div className={accordionLabelDescriptionIcon}>{icon}</div>}
        </div>
      </div>

      <div className={accordionRightContent}>{rightContent}</div>
    </div>
  );
};
